import { render, staticRenderFns } from "./SecondStep.vue?vue&type=template&id=532bf5be&"
import script from "./SecondStep.ts?vue&type=script&lang=ts&"
export * from "./SecondStep.ts?vue&type=script&lang=ts&"
import style0 from "./SecondStep.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports